import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EventsOverlayComponent } from './events-overlay.component';
import { EventsListModule } from '@lists/_index';

@NgModule({
  imports: [CommonModule, EventsListModule, EventsOverlayComponent],
  exports: [EventsOverlayComponent],
})
export class EventsOverlayModule {}
